import React, { useState, useEffect, useCallback } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import AppBar from '@mui/material/AppBar';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { Box, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { Delete } from '@material-ui/icons';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { styled } from '@material-ui/styles';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import DoneIcon from '@material-ui/icons/Done';
import ChatIcon from '@mui/icons-material/Chat';
import VariationsIcon from '@mui/icons-material/ViewCarousel';
import moment from 'moment';
import { Popover } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import ReplyIcon from '@mui/icons-material/Reply';

import api from '../../../../../services/api';

import {
    DataGrid, ptBR,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import {
    MaterialReactTable
} from 'material-react-table';


import { Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';

import { Email, EmailOutlined, Visibility, VisibilityOff, Message, MessageOutlined } from '@mui/icons-material';
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";



export default function AnaliseOrcamentaria({
    ordemCompra,
    columnsItensDataGrid,
    isSolicitante,
    isSupervisor,
    handleClickMotivoEscolha,
    autorizou,
    handleOpenAutorizar,
    telaCheia,
    handleToggleTelaCheia,
    objetosAnalise,
    columnsAnalise,
    infoOrdem,
    currencyFormatter,
    valorTotalGlobal,
    valorFreteGlobal,
    isDark,
}) {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // <=600px


    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "info-popover" : undefined;

    return (
        <>
            {ordemCompra.ordem_servico ?
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    align="flex-start"
                    item xs={4}
                    style={{ marginTop: 5 }}
                >
                    <Tooltip
                        title={
                            <div
                                style={{
                                    backgroundColor: 'white',
                                    height: '80vh',             // 50% da altura da viewport
                                    width: '80vw',              // 50% da largura da viewport
                                    overflow: 'auto',           // adiciona scroll se necessário
                                    border: '2px solid black',
                                }}
                            >

                                <Grid
                                    container
                                    direction="row"
                                    item xs={12}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    {
                                        ordemCompra.ordem_servico?.itens_pre_requerimento &&
                                        <>
                                            <DataGrid
                                                rows={ordemCompra.ordem_servico.itens_pre_requerimento}
                                                getRowId={(row) => row.id_item_requerimento}
                                                columns={columnsItensDataGrid}
                                                disableColumnResize={false}
                                                rowHeight={30}

                                            />

                                        </>
                                    }



                                </Grid>
                            </div>
                        }
                        placement="right"
                        arrow
                        style={{ backgroundColor: 'white', color: isDark ? 'white' : 'black' }}
                        sx={{ backgroundColor: 'white', color: isDark ? 'white' : 'black' }}
                    >
                        <IconButton aria-label="Requerimento de Itens" style={{ color: 'black', fontSize: 12 }}>
                            <HelpOutlineIcon color='blue' >
                            </HelpOutlineIcon>
                            Requerimento de Itens
                        </IconButton>
                    </Tooltip>
                </Grid>
                :
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    align="flex-start"
                    item xs={4}
                    style={{ marginTop: 5 }}
                >
                    <Tooltip
                        title={
                            <div


                                style={{
                                    backgroundColor: 'white',
                                    height: '80vh',             // 50% da altura da viewport
                                    width: '80vw',              // 50% da largura da viewport
                                    overflow: 'auto',           // adiciona scroll se necessário
                                    border: '2px solid black',
                                }}                                                        >

                                <Grid
                                    container
                                    direction="row"
                                    item xs={12}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    {
                                        ordemCompra.itens_pre_requerimento &&
                                        <>
                                            <DataGrid
                                                rows={ordemCompra.itens_pre_requerimento}
                                                getRowId={(row) => row.id_item_requerimento}
                                                columns={columnsItensDataGrid}
                                                disableColumnResize={false}
                                                rowHeight={30}

                                            />

                                        </>
                                    }



                                </Grid>
                            </div>
                        }
                        placement="right"
                        arrow
                        style={{ backgroundColor: 'white' }}
                        sx={{ backgroundColor: 'white' }}
                    >
                        <IconButton aria-label="Requerimento de Itens" style={{ color: isDark ? 'white' : 'black', fontSize: 12 }}>
                            <HelpOutlineIcon color='blue' >
                            </HelpOutlineIcon>
                            Requerimento de Itens
                        </IconButton>
                    </Tooltip>
                </Grid>
            }

            {(ordemCompra.status === 1 && (isSolicitante || isSupervisor)) ?
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    item xs={3}
                >
                    <Tooltip title="Encerrar Análise para entrar em cadeia de autorização">
                        <Button onClick={(e) => handleClickMotivoEscolha(true)}>
                            <DoneIcon style={{ margin: 5, marginTop: 5 }} />
                            <span style={{ fontSize: 12, color: isDark ? 'white' : 'black' }}>Encerrar Análise</span>
                        </Button>
                    </Tooltip>
                </Grid>
                :
                (isSolicitante || isSupervisor) && !autorizou && ordemCompra.status >= 2 ?

                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="flex-end"
                        item xs={6}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleOpenAutorizar}
                        > Autorizar  </Button>
                    </Grid>
                    :
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="flex-end"
                        item xs={6}
                    >
                    </Grid>



            }


            <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="flex-end"
                item xs={1}
            >

                <Tooltip title={telaCheia ? 'Sair da Tela Cheia' : 'Tela Cheia'}>
                    <Button
                        variant="outlined"
                        onClick={handleToggleTelaCheia}
                        style={{
                            backgroundColor: isDark ? '#333' : 'white',
                            border: '1px solid #ccc',
                            minWidth: 0,
                            padding: '6px 12px',
                            fontSize: '0.75rem',
                            textTransform: 'none',
                            fontWeight: 'bold',
                            color: isDark ? 'white' : 'black',
                        }}
                    >
                        {telaCheia ? 'Sair' : 'Tela Cheia'}
                    </Button>
                </Tooltip>
            </Grid>

            <>
                {objetosAnalise && (
                    <Grid
                        container
                        direction="row"
                        item xs={12}
                        alignItems="center"
                        justifyContent="center"
                        style={{ width: '100%', margin: 0, padding: 0 }}
                    >
                        <Grid
                            container
                            direction="row"
                            item xs={12}
                            alignItems="center"
                            justifyContent="center"
                            style={{ width: '100%', margin: 0, padding: 0, color: 'black' }}
                        >
                            <MaterialReactTable
                                columns={columnsAnalise}
                                data={objetosAnalise}
                                enableTopToolbar={false}
                                enableBottomToolbar={false}
                                enablePagination={false}
                                enableColumnFilters={false}
                                enableColumnActions={false}
                                enableStickyHeader
                                sortable={false}
                                enableSorting={false}
                                enableRowSelection={false}
                                color={'black'}
                                paginationDisplayMode={'pages'}
                                getRowId={(row) => row.id_item_analise}
                                initialState={{
                                    showGlobalFilter: true,
                                    color: 'black',
                                    columnPinning: { left: ['Descrição'] }
                                }}
                                muiTableContainerProps={{
                                    sx: {
                                        maxHeight: telaCheia ? 'calc(100vh - 150px)' : 'calc(100vh - 330px)', // ajuste 200px conforme altura do topo/botões
                                    },
                                }}
                                muiTableBodyRowProps={{
                                    sx: {
                                        height: 40,
                                        color: 'black' // Define a cor do texto para preto
                                    },
                                }}
                                enableColumnFilterModes={false}
                                enableExpandAll={true}
                                enableColumnPinning={true}
                                enableColumnResizing={true}

                                enableFullScreenToggle={true}
                                muiTablePaperProps={({ table }) => ({
                                    style: {
                                        zIndex: table.getState().isFullScreen ? 1000 : undefined,
                                        color: 'black',
                                    },
                                })}
                            />
                        </Grid>


                        <Grid
                            container
                            direction="row"
                            item xs={12}
                            alignItems="center"
                            justifyContent="center"
                            style={{ paddingTop: 2 }}
                        >

                            <Grid
                                container
                                direction="row"
                                item
                                xs={2}
                                alignItems="center"
                                justifyContent={isMobile ? "center" : "flex-start"} // ajuste de alinhamento
                                style={{ marginTop: 8 }}
                            >
                                <>
                                    {/* Animação leve de piscar */}
                                    <style>
                                        {`
            @keyframes blink {
              0%, 100% { opacity: 1; }
              50% { opacity: 0.85; }
            }
          `}
                                    </style>

                                    <IconButton
                                        aria-label="Informações"
                                        onClick={handleClick}
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            border: "2px solid blue",
                                            borderRadius: "12px",
                                            padding: "5px",
                                            animation: "blink 1.5s infinite",
                                            cursor: "pointer",
                                            backgroundColor: isDark ? '#333' : 'white',
                                            color: isDark ? 'white' : 'black',
                                        }}
                                    >
                                        <InfoIcon style={{ color: "blue", fontSize: 26, paddingLeft: isMobile ? 0 : '10px' }} />
                                        <span style={{ fontSize: 16, fontWeight: "bold", color: "black", marginTop: 4 }}>
                                            Informações
                                        </span>
                                    </IconButton>
                                </>

                                <Popover
                                    id={id}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "left",
                                    }}
                                    PaperProps={{
                                        style: {
                                            backgroundColor: "white",
                                            maxHeight: "400px",
                                            width: isMobile ? "80vw" : undefined, // 80% da largura da tela no mobile
                                            minWidth: isMobile ? undefined : "580px",
                                            maxWidth: isMobile ? undefined : "600px",
                                            overflow: "auto",
                                            border: "2px solid black",
                                            color: "black",
                                            padding: "16px",
                                            zIndex: 9999,
                                        },
                                    }}
                                >
                                    <Grid
                                        container
                                        direction="row"
                                        item
                                        xs={12}
                                        alignItems="flex-start"
                                        justifyContent="flex-start"
                                    >
                                        <Typography>
                                            <Box sx={{ whiteSpace: "pre-line" }}>
                                                {"Informações:\n" + infoOrdem}
                                            </Box>
                                        </Typography>
                                    </Grid>
                                </Popover>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                item xs={9}
                                alignItems="center"
                                justifyContent="center"
                                style={{ paddingTop: 5 }}
                            >
                                <Stack>

                                    <Box>
                                        Valor Total Cotações Selecionadas:

                                        {currencyFormatter.format(valorTotalGlobal)}
                                    </Box>
                                    <Box>
                                        Valor Frete Cotações Selecionadas:

                                        {currencyFormatter.format(valorFreteGlobal)}
                                    </Box>
                                    <Box>
                                        Valor Total Final:

                                        {currencyFormatter.format(valorTotalGlobal + valorFreteGlobal)}
                                    </Box>


                                </Stack>
                            </Grid>




                        </Grid>
                    </Grid>

                )}
            </>

        </>

    );


}

